import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkUpdatePagesListByBrand } from "../api/bulkUpdatePagesListByBrand";
import { createPage } from "../api/createPage";
import {
  getPagesListByBrandQueryData,
  invalidatePagesListByBrandsQuery,
} from "../queries/usePagesListByBrandQuery";
import { PageDataToCreate } from "../types";

type Params = {
  data: PageDataToCreate;
  brandId: string;
};

export const useCreatePageMutation = (onSuccess: () => void) => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ data, brandId }) => {
      const prevData = getPagesListByBrandQueryData(brandId) || [];

      await Promise.all([
        createPage({ brandId, pageData: data }),
        bulkUpdatePagesListByBrand(
          brandId,
          prevData.map((page) => ({
            id: page.id,
            order: page.order + 1,
          })),
        ),
      ]);
    },
    onSuccess: (_, { brandId }) => {
      invalidatePagesListByBrandsQuery(brandId);
      onSuccess && onSuccess();
    },
    onError: (e) => {
      console.error("Error occurred when creating page", e);
    },
  });
};
